import { FormItemController } from "./FormItemController";
import { MultiCheck } from "../../HTML/Form/Item/MultiCheck";
import { toMap } from "../../../../HA";

/**
 * Contrôleur du groupe de checkboxes multi-choix (ft "mchk", HA-75).
 * `getValue()` (hérité) délègue à l'item : TABLEAU des valeurs cochées —
 * FormController détecte le tableau et append chaque valeur au FormData.
 */
export class MultiCheckController extends FormItemController {

    public isInputItem(): boolean {
        return true;
    }

    protected createItem() {
        return new MultiCheck(toMap({tag: this.getTag()}));
    }
}
